import { IDisease, IFishGroup, ISite, IUnit } from "../../varibles/interface";
import { createSliceSelectors } from "../selectors";
import type { AppState } from "../store";

export const NAME_SLICE = 'site'

export interface IUnitOverview extends IUnit {
    site: ISite
    region_id?: string
    group_name?: string
    group_id?: string
}

export interface SiteState {
    data: ISite[]
    dashboard: ISite[]

    loading: boolean

    overview: {
        data: IUnitOverview[]
        proAreas: Set<string>
        diseases: { [id: string]: IDisease }
        loading: boolean
        amount: { [id: string]: number }
    }

    fishGroup: {
        data: IFishGroup[]
        loading: boolean
    }
}

export const initialState: SiteState = {
    data: [],
    dashboard: [],

    loading: false,

    overview: {
        data: [],
        proAreas: new Set([]),
        diseases: {},
        loading: false,
        amount: {}
    },
    fishGroup: {
        data: [],
        loading: false
    }
}

const selectors = createSliceSelectors(NAME_SLICE, initialState);

export const selectSite = {
    ...selectors,
    proAreas: (state: AppState) => selectors.overview(state).proAreas,
    diseases: (state: AppState) => selectors.overview(state).diseases,
    amount: (state: AppState) => selectors.overview(state).amount,
};
